import React, { useState } from "react";
import { Flex } from "styles/utility-components";

import Button from "components/ui/button/Button";
import { EventNames, useTracking } from "../../lib/tracking";
import { ScheduleReminderModal } from "./ScheduleReminderModal";
import { ReminderDataType } from "./utils";

type Props = {
  dataType: ReminderDataType;
  anchorDate?: string | null;
  anchorType?: "expiry" | "close";
  dataId: string;
  dataTitle: string;
  buttonRender?: React.ReactNode;
};

export function ScheduleReminderButton(props: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { logEvent } = useTracking();

  const handleOpen = () => {
    setIsModalOpen(true);
    logEvent(EventNames.scheduleReminderModalOpened, {
      dataType: props.dataType,
      dataId: props.dataId,
      dataTitle: props.dataTitle,
      anchorDate: props.anchorDate,
      anchorType: props.anchorType,
    });
  };

  return (
    <>
      <Flex onClick={handleOpen}>
        {props.buttonRender ? (
          props.buttonRender
        ) : (
          <Button buttonType="secondary" icon="clockRewind" onClick={handleOpen}>
            Reminder
          </Button>
        )}
      </Flex>
      <ScheduleReminderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        {...props}
      />
    </>
  );
}
